exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-box .el-table__header tr,\n.el-table__header th {\n  padding: 0;\n  height: 40px;\n  line-height: 50px;\n  text-align: center;\n}\n.el-table__body tr,\n.el-table__body td {\n  padding: 0;\n  height: 30px;\n  line-height: 30px;\n  text-align: center;\n}", ""]);

// exports
